const defaultMapping = [
  {
    type: '100',
    percentage: 80,
  },
  {
    type: '200',
    percentage: 60,
  },
  {
    type: '300',
    percentage: 40,
  },
  {
    type: '400',
    percentage: 20,
  },
  {
    type: '600',
    percentage: 20,
  },
  {
    type: '700',
    percentage: 40,
  },
  {
    type: '800',
    percentage: 60,
  },
  {
    type: '900',
    percentage: 80,
  },
  {
    type: 'base',
  },
]

const colorMappings = [
  {
    key: 'primaryColor',
    varName: '--color-primary',
    baseColor: '#0d4491',
    mappings: [
      {
        type: 'onhoverclick',
        percentage: -10,
      },
      ...defaultMapping,
    ],
  },
  {
    key: 'secondaryColor',
    varName: '--color-secondary',
    baseColor: '#1c74da',
    mappings: [...defaultMapping],
  },
  {
    key: 'fontColor',
    varName: '--color-text',
    baseColor: '#01133d',
    mappings: [...defaultMapping],
  },
]

export default colorMappings
